import { ReactNode } from 'react';
import { Button, IButtonProps } from '@/common/components/Button/Button';
import { Section } from '@/common/components/Section/Section';

export type THomeSectionProps = {
  title?: string;
  action?: IButtonProps;
  children: ReactNode;
};

export function HomeSection({ title, action, children }: THomeSectionProps) {
  return (
    <Section
      title={title}
      action={action && <Button {...action} variant="tertiary" size="sm" />}
    >
      {children}
    </Section>
  );
}
